import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../index'

const counts = (state: RootState) => state.counts

export const countsSelector = createSelector([counts], counts => counts)
